import { useState } from 'react';
import DottedList from 'components/dotted-list';
import ImageCarousel, { CarouselImage } from 'components/image-carousel';
import clsx from 'clsx';
import ModalCarousel from '../modals/modalAnalogs/modalCarousel';
import {
  IPrimaryFacilityRecommendationsResponse,
  ISecondaryFacilityRecommendationsResponse,
} from 'screens/estimate/interfaces';

import style from '../aboutObject/styles.module.scss';
import { estimateHaveRecommendations } from 'lib/utils';
import { AboutObjectEstimateButtonRecommendations } from './aboutObjectEstimateButtonAnalog';
import { AboutObjectEstimateMarketPrice } from './aboutObjectEstimateMarketPrice';
interface IAboutObjectEstimatesProps {
  recommendations:
    | ISecondaryFacilityRecommendationsResponse
    | IPrimaryFacilityRecommendationsResponse;
  sameFacilityCount: number;
  maxFacilityPrice: string;
  minFacilityPrice: string;
  marketPrice: string;
  floorCount: number;
  wallMaterial: string;
  commissioningYear: string;
  address: string;
  images?: CarouselImage[];
  isSecondary: boolean;
}

const AboutObjectEstimate = ({
  recommendations,
  marketPrice,
  sameFacilityCount,
  maxFacilityPrice,
  minFacilityPrice,
  floorCount,
  wallMaterial,
  isSecondary,
  commissioningYear,
  address,
  images,
}: IAboutObjectEstimatesProps) => {
  const [isOpenModalCarousel, setIsOpenModalCarousel] = useState(false);

  const handleChangeModalCarousel = (value: boolean) => {
    setIsOpenModalCarousel(value);
  };

  const isRecommendations = estimateHaveRecommendations(recommendations);

  return (
    <div className={style.aboutObject}>
      <div className={style.aboutObject__container}>
        <div className={style.aboutObject__card}>
          <div className={style.aboutObject__title}>
            <h4>Информация по квартире:</h4>
          </div>

          <div className={clsx(style.aboutObject__marketPrice, style.marketPrice)}>
            <AboutObjectEstimateMarketPrice
              marketPrice={marketPrice}
              maxFacilityPrice={maxFacilityPrice}
              minFacilityPrice={minFacilityPrice}
            />

            <div className={style.aboutObject__about}>
              <div className={style.aboutObject__dottedList}>
                <DottedList
                  items={[
                    { label: 'Адрес', value: address },
                    { label: 'Материал стен', value: wallMaterial },
                    { label: 'Год постройки', value: commissioningYear },
                    { label: 'Этажность', value: floorCount },
                  ]}
                />
              </div>
            </div>

            {!!images?.length && (
              <div className={style.aboutObject__imageCarousel}>
                <ImageCarousel
                  images={images}
                  className={style.carousel}
                  isCarouselInDetails
                  isCustomSwipeIcon
                  topPadding
                  isSecondary={false}
                  borderRadius={20}
                  onOpenBigCarousel={handleChangeModalCarousel}
                />
                <ModalCarousel
                  isOpen={isOpenModalCarousel}
                  onDismiss={handleChangeModalCarousel}
                  images={images}
                />
              </div>
            )}

            {isRecommendations && (
              <AboutObjectEstimateButtonRecommendations
                isSecondary={isSecondary}
                recommendations={recommendations}
                sameFacilityCount={sameFacilityCount}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutObjectEstimate;
